import styled from "styled-components";

export const ContainerIcon = styled.span`
  display: inline;
  margin-left: 5px;
`;
